import notify from "./notify/zhTW";

export default {
    notify: notify
}
